import { useEffect } from 'react'
import { trackGAEvent } from '@moonpig/web-core-analytics'
import { localStore } from '@moonpig/web-core-browser-storage'

export const SendGALoginEvent = () => {
  useEffect(() => {
    const send = async () => {
      const loginEventType = localStore.getItem('mnpg_send_ga_login_event')

      if (!loginEventType) {
        return
      }

      trackGAEvent({
        event: 'login',

        event_data: {
          category: 'account',
          action: 'login success',
          label: loginEventType,
          non_interaction: true,
          value: undefined,
        },
      })

      localStore.removeItem('mnpg_send_ga_login_event')
    }

    send()
  }, [])

  return null
}
